/*
 * Ryan O'Dowd
 * 2025-06-11
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ActivityIndicator as PaperActivityIndicator,
} from 'react-native-paper';
import React from 'react';

const ActivityIndicator = (props: React.ComponentProps<typeof ActivityIndicator>) => {
  return (
    <PaperActivityIndicator
      {...props}
    />
  );
};

export default ActivityIndicator;
